module.exports = __webpack_public_path__ + "img/banner4.9bbc408f.png";